module.exports = __webpack_public_path__ + "img/icon_map_6_on_111.aa49c78e.png";